module.exports = __webpack_public_path__ + "img/icon4.27a37ea8.png";